import { Component, ViewChild } from '@angular/core'
import { type FirstDataRenderedEvent, type RowNode, type GridApi, type GridReadyEvent } from 'ag-grid-community'
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog'
import { RecoBuyQtyRepo_GenerateGridData } from 'src/app/05_ag-grid-configs/04_generate-colDefs/reco-buy-qty-repo-colDefs'
import $recoBuyQtyRepo from 'src/app/05_ag-grid-configs/01_json-grid-configs/reco-buy-qty/colDefs-reco-buy-qty-repo.json'
import { CustomGridOptions } from 'src/app/05_ag-grid-configs/02_global-settings/grid-options'
import { RecoBuyQtyAPIs } from 'src/app/core/apis/reco-buy-qty_api-calls'
import { ConfirmPopupComponent } from 'src/app/03_shared-components/01_alerts/confirm-popup/confirm-popup.component'
import moment from 'moment'

@Component({
  standalone: false,
  selector: 'app-reco-buy-qty-repo-modal',
  templateUrl: './reco-buy-qty-repo-modal.component.html',
  styleUrls: ['./reco-buy-qty-repo-modal.component.scss']
})
export class RecoBuyQtyRepoModalComponent {
  rowData: any[] = []
  originalRowData: any[] = []
  columnDefs = []
  gridApi: GridApi

  modalTitle = 'Plan Repository'

  loading = true

  planNameToDelete: string

  gridOptions = {
    ...CustomGridOptions,
    defaultColDef: {
      autoHeaderHeight: true,
      wrapHeaderText: true
    },
    context: {
      componentParent: this,
      getPlan: (planName: string) => this.ref.close(planName),
      deletePlan: (planName: string) => {
        this.planNameToDelete = planName
        this.confirmPopupDelete.confirm(event, 'Delete Size Range Definitions')
      }
    },
    getRowId: (node: RowNode) => {
      return node.data.plan_name
    }
  }

  repoSearchText: string
  selectedStatus: string = 'All'

  deletePlan: Function

  public recoBuyQtyRepo = $recoBuyQtyRepo

  @ViewChild('confirmPopupDelete') confirmPopupDelete: ConfirmPopupComponent

  constructor (
    public readonly ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    public recoBuyQtyApi: RecoBuyQtyAPIs
  ) {
    console.log('---> Reco Buy Qty Repo Modal: ', config.data)
    this.deletePlan = config.data.deletePlan
    this.recoBuyQtyApi.getRecoPlans().subscribe(data => {
      console.log('Reco plans: ', data)
      this.rowData = data
      this.originalRowData = data
    })
  }

  onGridReady (event: GridReadyEvent) {
    this.gridApi = event.api

    RecoBuyQtyRepo_GenerateGridData({ mainColDefs: this.recoBuyQtyRepo[0] as any }).then(data => {
      this.columnDefs = data.mainColDefs
    })
  }

  onFirstDataRendered (event: FirstDataRenderedEvent) {
    this.loading = false
  }

  onRepoSearch (value: string): void {
    this.repoSearchText = (value || '').trim()
    this.applyRepoFilters()
  }

  onStatusFilterChange (): void {
    this.applyRepoFilters()
  }

  private applyRepoFilters (): void {
    let filtered = this.originalRowData

    if (this.repoSearchText) {
      const term = this.repoSearchText.toLowerCase()
      filtered = filtered.filter(
        row =>
          row.plan_name?.toLowerCase().includes(term) ||
                    row.season?.toLowerCase().includes(term) ||
                    row.created_by?.toLowerCase().includes(term) ||
                    moment(row.created_at).format('LLL').toLowerCase().includes(term) ||
                    moment(row.last_modified).format('LLL').toLowerCase().includes(term)
      )
    }

    if (this.selectedStatus !== 'All') {
      filtered = filtered.filter(row => {
        console.log('row.status', row.status)
        return row.reco_quantification?.toLowerCase() === this.selectedStatus.toLowerCase()
      })
    }

    this.rowData = filtered

    if (this.gridApi) {
      this.gridApi.setGridOption('rowData', this.rowData)
    }
  }

  onDeletePlan () {
    this.deletePlan(() => {
      this.gridApi.applyTransaction({ remove: [{ plan_name: this.planNameToDelete }] })
    }, this.planNameToDelete)
  }
}
